import React from "react";
export default function CommercialFavorites({
  state,
  client,
  onChange,
  onSelect,
}) {
  const ids = state.commercialFavorites || [],
    key = client ? String(client.client_id || client.id) : "",
    favorites = state.clients.filter((c) =>
      ids.includes(String(c.client_id || c.id)),
    );
  return (
    <details className="rounded-xl border p-3">
      <summary>Mes favoris ({favorites.length})</summary>
      <div className="mt-3 flex flex-wrap gap-2">
        {client && (
          <button
            type="button"
            className="secondary"
            onClick={() =>
              onChange(
                ids.includes(key)
                  ? ids.filter((id) => id !== key)
                  : [...ids, key],
              )
            }
          >
            {ids.includes(key)
              ? "Retirer des favoris"
              : "Ajouter " + client.name + " aux favoris"}
          </button>
        )}
        {favorites.map((c) => (
          <button
            type="button"
            className="secondary"
            key={c.id}
            onClick={() => onSelect(c.id)}
          >
            {c.name}
          </button>
        ))}
        {!favorites.length && <p>Aucun favori enregistré.</p>}
      </div>
    </details>
  );
}
